//message.js
import React from 'react'

const Message = ({ message }) => {
	return <div className='p-10 w-full text-center text-xl '>{message}</div>
}

export default Message
